import React, { useState, useEffect,useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Paper,
  Typography,
  Box,
  Divider,
  Button,
  Fab,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  ListItemIcon,
  Chip,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Breadcrumbs,
  Link,
  useTheme,
} from "@mui/material";
import { teal, green } from "@mui/material/colors";
import axios from "axios";
// Iconos
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveIcon from "@mui/icons-material/Save";
import LayersClearIcon from "@mui/icons-material/LayersClear";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArticleIcon from "@mui/icons-material/Article";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import SettingsIcon from "@mui/icons-material/Settings";
import RuleIcon from "@mui/icons-material/Rule";
import HomeIcon from "@mui/icons-material/Home";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import SearchOffIcon from "@mui/icons-material/SearchOff";

//Componentes Importados
import Restricted from "components/Restricted";
import { Build, School } from "@mui/icons-material";

// --- Datos de Ejemplo ---
// const mockSavedExams = [
//   {
//     id: 9001,
//     name: "EXAMEN DE NUTRICIÓN - TRIMESTRE 1",
//     category: "Nutrición",
//     description: "Evaluación trimestral sobre nutrición básica.",
//     durationInSeconds: 1800,
//     questionLimit: 2,
//     passingScore: 1,
//     questions: [
//       {
//         id: 101,
//         question: "¿Cuál es la principal fuente de vitamina C?",
//         difficulty: "Basico",
//         answers: [
//           { text: "Manzanas", isCorrect: false },
//           { text: "Naranjas", isCorrect: true },
//         ],
//       },
//       {
//         id: 102,
//         question: "Pregunta sobre lactancia",
//         difficulty: "Basico",
//         answers: [
//           { text: "Verdadero", isCorrect: true },
//           { text: "Falso", isCorrect: false },
//         ],
//       },
//     ],
//     isActive: true,
//   },
//   {
//     id: 9002,
//     name: "PRUEBA DE SALUD BÁSICA",
//     category: "Salud",
//     description: "",
//     durationInSeconds: 600,
//     questionLimit: 1,
//     passingScore: 1,
//     questions: [
//       {
//         id: 201,
//         question: "Pregunta sobre deshidratación",
//         difficulty: "Intermedio",
//         answers: [
//           { text: "Ojos Hundidos", isCorrect: true },
//           { text: "Piel Elástica", isCorrect: false },
//         ],
//       },
//     ],
//     isActive: false,
//   },
// ];

const CrearTest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const nav = useNavigate();
 // const availablePools = location.state?.pools || [];

  const theme = useTheme();
  const [categorias, setCategorias] = useState([]); 
  const [poolDePreguntas, setPoolDePreguntas] = useState([]); // 'savedExams' ya existe en tu código, solo nos aseguraremos de que se inicialice vacío. 
  const [loading, setLoading] = useState(true);
  const [items, setItems] = React.useState([]);
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  const handleLinkHome = (event, message) => {
    if (message === "home") nav("/inicio");
  };
  const handleLinkGestion = (event, message) => {
    if (message === "gestion") nav("/gestionhumana");
  };

  const handleLinkTest = (event, message) => {
    if (message === "test") nav("/testDashboard");
  };

  const [examName, setExamName] = useState("");
  const [questionLimit, setQuestionLimit] = useState("");
  const [examTime, setExamTime] = useState("");
  const [examDescription, setExamDescription] = useState("");
  const [passingScore, setPassingScore] = useState("");
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedDifficulty, setSelectedDifficulty] = useState(null);

  const [savedExams, setSavedExams] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSavedExam, setSelectedSavedExam] = useState(null);
  const [savedExamCategoryFilter, setSavedExamCategoryFilter] =
    useState("Todos");
  const [savedExamDifficultyFilter, setSavedExamDifficultyFilter] =
    useState("Todos");

  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [detailsTab, setDetailsTab] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editTab, setEditTab] = useState(0);
  const [editingExam, setEditingExam] = useState(null);
  const [editModalCategoryFilter, setEditModalCategoryFilter] =
    useState("Todos");
  const [editModalDifficultyFilter, setEditModalDifficultyFilter] =
    useState("Todos");
 // --- AÑADE ESTE BLOQUE COMPLETO ---
 const fetchData = async () => {
  setLoading(true);
  try {
    const [categoriasRes, preguntasRes, examenesRes] = await Promise.all([
      axios.get("/categoriasExamen"),
      axios.get("/preguntasExamen"),
      axios.get("/Examen"),
    ]);
    console.log(categoriasRes.data)
    console.log(preguntasRes.data)
    console.log(examenesRes.data, "Examenes Todos");
    setCategorias(categoriasRes.data);
    setPoolDePreguntas(preguntasRes.data);
    setSavedExams(examenesRes.data);
    console.log(examenesRes.data);
  } catch (error) {
    console.error("Error al cargar datos:", error);
    showSnackbar("Error cargando datos del servidor.", "error");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchData();
}, []); // El array vacío asegura que se ejecute solo una vez al inicio

const difficultyToLabel = (n) =>
 n === 1 ? "Basico" : n === 2 ? "Intermedio" : "Experto";

  const openMenu = Boolean(anchorEl);
  const isSelectionDisabled =
    !examName.trim() ||
    !questionLimit ||
    !examTime ||
    !passingScore ||
    !examDescription.trim() ||
    parseInt(questionLimit, 10) <= 0 ||
    parseInt(examTime, 10) <= 0 ||
    parseInt(passingScore, 10) <= 0 ||
    selectedCategoryId ===null ||
    selectedDifficulty === null;

// ---- LÓGICA DE FILTRADO + AGRUPADO EN POOLS ----
// ---- LÓGICA DE FILTRADO AGRUPADO EN POOLS ----
const filteredPools = useMemo(() => {
  console.group("filteredPools useMemo");

  console.log("loading:", loading);
  console.log("poolDePreguntas (raw):", poolDePreguntas);
  console.log("selectedCategoryId:", selectedCategoryId, "selectedDifficulty:", selectedDifficulty);

  if (loading || !Array.isArray(poolDePreguntas)) {
    console.log("Saliendo: loading=true o poolDePreguntas no es array");
    console.groupEnd();
    return [];
  }

  // 1) Filtrar por categoría y dificultad numérica del backend
  const filtradas = poolDePreguntas.filter((p) => {
    const catOk =
      selectedCategoryId == null || p.id_categoria == selectedCategoryId;
    const diffOk =
      selectedDifficulty == null || p.dificultad == selectedDifficulty;

    console.log(
      "Evaluando pregunta:",
      {
        id_pregunta: p.id_pregunta,
        id_categoria: p.id_categoria,
        dificultad: p.dificultad,
      },
      "=> catOk:",
      catOk,
      "diffOk:",
      diffOk
    );

    return catOk && diffOk;
  });

  console.log("filtradas (después de categoría/dificultad):", filtradas);

  // 2) Agrupar por categoría y mapear a estructura de pool UI
  const byCat = new Map();
  for (const p of filtradas) {
    const catId = p.id_categoria;
    const catName = p?.categoria?.nombre_categoria ?? `Categoría ${catId}`;

    if (!byCat.has(catId)) {
      console.log("Creando pool para categoría:", catId, catName);
      byCat.set(catId, {
        id: catId,
        name: catName,
        category: catName,
        questions: [],
      });
    }

    const mappedQuestion = {
      id: p.id_pregunta,
      question: p.enunciado_pregunta,
      answers: (p.respuestas ?? []).map((r) => ({
        text: r.texto_respuesta,
        isCorrect: !!r.es_correcta,
      })),
      difficulty: difficultyToLabel(p.dificultad),
    };

    console.log("Agregando pregunta al pool:", catId, mappedQuestion);

    byCat.get(catId).questions.push(mappedQuestion);
  }

  const result = Array.from(byCat.values());
  console.log("filteredPools result:", result);
  console.groupEnd();
  return result;
}, [poolDePreguntas, selectedCategoryId, selectedDifficulty, loading]);


console.log(loading)
console.log(filteredPools,"este")
console.log(selectedCategoryId)
console.log(selectedDifficulty)
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleAddQuestion = (questionToAdd) => {
    if (questionLimit && selectedQuestions.length >= questionLimit) {
      showSnackbar(
        `No se pueden añadir más de ${questionLimit} preguntas.`,
        "error"
      );
      return;
    }
    if (!selectedQuestions.some((q) => q.id === questionToAdd.id)) {
      setSelectedQuestions((prev) => [...prev, questionToAdd]);
    }
  };

  const handleRemoveQuestion = (questionId) => {
    setSelectedQuestions((prev) => prev.filter((q) => q.id !== questionId));
  };

// const difficultyToLabel = (n) =>
//  n === 1 ? "Basico" : n === 2 ? "Intermedio" : "Experto";

const handleAddAllFromPool = (pool) => {
  const limit = parseInt(questionLimit || "0", 10);
  if (!limit || limit <= 0) {
    showSnackbar(
      "Por favor, establece una cantidad válida de preguntas para el examen.",
      "error"
    );
    return;
  }
  const availableSlots = limit - selectedQuestions.length;
  if (availableSlots <= 0) {
    showSnackbar("Ya has alcanzado el límite de preguntas.", "error");
    return;
  }

  const allFromPool = Array.isArray(pool?.questions) ? pool.questions : [];

  // selectedDifficulty es número (1|2|3) o null
  const normalizedLabel =
    selectedDifficulty == null ? null : difficultyToLabel(selectedDifficulty);

  const candidates = allFromPool
    .filter((q) => !normalizedLabel || q.difficulty == normalizedLabel)
    .filter((q) => !selectedQuestions.some((sq) => sq.id == q.id));

  if (candidates.length === 0) {
    showSnackbar(
      "No hay preguntas disponibles para añadir desde este pool.",
      "warning"
    );
    return;
  }

  const shuffled = [...candidates];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  const questionsToAdd = shuffled.slice(
    0,
    Math.min(availableSlots, shuffled.length)
  );
  setSelectedQuestions((prev) => [...prev, ...questionsToAdd]);
};

 const handleClearExam = () => {
  setExamName("");
  setQuestionLimit("");
  setExamTime("");
  setExamDescription("");
  setPassingScore("");
  setSelectedQuestions([]);
  setSelectedCategoryId(null);
  setSelectedDifficulty(null);
};

  // const handleSaveExam = () => {
  //   const trimmedName = examName.trim().toUpperCase();
  //   if (
  //     !trimmedName ||
  //     selectedQuestions.length === 0 ||
  //     !questionLimit ||
  //     !examTime ||
  //     !passingScore
  //   ) {
  //     showSnackbar(
  //       "Por favor, completa todos los campos de configuración y selecciona al menos una pregunta.",
  //       "error"
  //     );
  //     return;
  //   }
  //   if (parseInt(passingScore, 10) > parseInt(questionLimit, 10)) {
  //     showSnackbar(
  //       "Las preguntas para aprobar no pueden ser mayores que la cantidad total de preguntas.",
  //       "error"
  //     );
  //     return;
  //   }
  //   const isDuplicate = savedExams.some(
  //     (exam) => exam.name.toLowerCase() === trimmedName.toLowerCase()
  //   );
  //   if (isDuplicate) {
  //     showSnackbar(
  //       "Ya existe un examen con este nombre. Por favor, elige otro.",
  //       "error"
  //     );
  //     return;
  //   }
  //   const examData = {
  //     id: Date.now(),
  //     name: trimmedName,
  //     description: examDescription.trim(),
  //     durationInSeconds: parseInt(examTime, 10) * 60,
  //     questionLimit: parseInt(questionLimit, 10),
  //     passingScore: parseInt(passingScore, 10),
  //     questions: selectedQuestions,
  //     category: selectedCategoryId,
  //     isActive: false,
  //   };
  //   setSavedExams((prev) => [...prev, examData]);
  //   showSnackbar("¡Examen guardado con éxito!", "success");
  //   handleClearExam();
  // };
  const handleSaveExam = async () => {
  if (
    !examName.trim() ||
    !questionLimit ||
    !examTime ||
    !passingScore ||
    selectedCategoryId == null ||
    selectedDifficulty== null ||
    selectedQuestions.length === 0
  ) {
    showSnackbar(
      "Por favor, completa todos los campos de configuración y selecciona al menos una pregunta.",
      "error"
    );
    return;
  }

  if (parseInt(passingScore, 10) > parseInt(questionLimit, 10)) {
    showSnackbar(
      "Las preguntas para aprobar no pueden ser mayores que la cantidad de preguntas del examen.",
      "error"
    );
    return;
  }

  const examData = {
    titulo_examen: examName.trim().toUpperCase(),
    id_categoria: Number(selectedCategoryId),
    dificultad: Number(selectedDifficulty), // 1|2|3
    tamano_examen: parseInt(questionLimit, 10),
    preguntas_para_aprobar: parseInt(passingScore, 10),
    tiempo_limite_minutos: parseInt(examTime, 10),
    activo: false,
    preguntas_ids: selectedQuestions.map((q) => q.id),
    // preguntas_meta: Object.fromEntries(
    //   selectedQuestions.map((q, idx) => [q.id, { orden: idx + 1, puntaje: 1 }])
    // ),
  };

  try {
    setLoading(true);
    await axios.post("/Examen", examData);
    showSnackbar("¡Examen guardado con éxito! Ahora puedes activarlo desde la lista.", "success");
    handleClearExam();
    fetchData();
  } catch (error) {
    console.error("Error al guardar el examen:", error);
    showSnackbar(error?.response?.data?.error || "Error al guardar el examen.", "error");
  } finally {
    setLoading(false);
  }
};

  const handleMenuOpen = async (event, examId) => {

setAnchorEl(event.currentTarget);

    try {
    // CAMBIO: Carga completa con preguntas y respuestas
    const { data } = await axios.get(`/detalleExamen/${examId}`);
    
    // Opcional: normalizar estructura si tu UI espera formato específico
    setSelectedSavedExam(data);
    console.log(data,"datos Examen");
    //setOpenDetailsModal(true);
  } catch (error) {
    console.error("Error cargando detalles:", error);
    showSnackbar("No se pudieron cargar los detalles del examen.", "error");
  }
    
    //console.log(exam,"examen seleccionado")
    //setSelectedSavedExam(exam);
  };




  const handleMenuClose = () => setAnchorEl(null);

  const handleDeleteExam = () => {
    setSavedExams((prev) =>
      prev.filter((exam) => exam.id !== selectedSavedExam.id)
    );
    showSnackbar("Examen eliminado correctamente.", "success");
    handleMenuClose();
  };
  const handleActivateExam = () => {
    if (selectedSavedExam) {
      setSavedExams((prevExams) =>
        prevExams.map((exam) =>
          exam.id === selectedSavedExam.id ? { ...exam, isActive: true } : exam
        )
      );
    }
    handleMenuClose();
  };
  const handleDeactivateExam = () => {
    if (selectedSavedExam) {
      setSavedExams((prevExams) =>
        prevExams.map((exam) =>
          exam.id === selectedSavedExam.id ? { ...exam, isActive: false } : exam
        )
      );
    }
    handleMenuClose();
  };

  const handleOpenDetailsModal = () => {
    setOpenDetailsModal(true);
    handleMenuClose();
  };
  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
    setTimeout(() => setDetailsTab(0), 300);
  };
  const handleDetailsTabChange = (event, newValue) => {
    setDetailsTab(newValue);
  };

  const handleOpenEditModal = () => {
    if (selectedSavedExam) {
      setEditingExam({ ...selectedSavedExam });
      setEditModalCategoryFilter(selectedSavedExam.category || "Todos");
    }
    setOpenEditModal(true);
    handleMenuClose();
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setEditingExam(null);
    setEditTab(0);
    setEditModalCategoryFilter("Todos");
    setEditModalDifficultyFilter("Todos");
  };
  const handleEditTabChange = (event, newValue) => {
    setEditTab(newValue);
  };
  const handleEditingExamChange = (field, value) => {
    if (editingExam) {
      setEditingExam((prev) => ({ ...prev, [field]: value }));
    }
  };
  const handleUpdateExam = () => {
    if (!editingExam) return;
    if (editingExam.passingScore > editingExam.questionLimit) {
      showSnackbar(
        "Las preguntas para aprobar no pueden ser mayores que la cantidad total.",
        "error"
      );
      return;
    }
    const isDuplicate = savedExams.some(
      (exam) =>
        exam.id !== editingExam.id &&
        exam.name.toLowerCase() === editingExam.name.trim().toLowerCase()
    );
    if (isDuplicate) {
      showSnackbar("Ya existe otro examen con este nombre.", "error");
      return;
    }
    setSavedExams((prev) =>
      prev.map((exam) => (exam.id === editingExam.id ? editingExam : exam))
    );
    showSnackbar("Examen actualizado con éxito", "success");
    handleCloseEditModal();
  };

  const displayedSavedExams = savedExams.filter((exam) => {
    const categoryMatch =
      savedExamCategoryFilter === "Todos" ||
      exam.category === savedExamCategoryFilter;
    const difficultyMatch =
      savedExamDifficultyFilter === "Todos" ||
      (exam.questions &&
        exam.questions.some((q) => q.difficulty === savedExamDifficultyFilter));
    return categoryMatch && difficultyMatch;
  });

  return (
    <div className="exclude">
      {rol === "1" || rol === "2" || rol === "7" ? (
        <>
          <Box m="1.5rem 2.5rem">
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/gestionhumana"
                  onClick={(event) => handleLinkGestion(event, "gestion")}
                >
                  <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestión Humana
                </Link>
                 <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/testDashboard"
                  onClick={(event) => handleLinkTest(event, "test")}
                >
                  <School sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestión de Exámenes
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <Build sx={{ mr: 0.5 }} fontSize="inherit" />
                  Constructor de Exámenes
                </Typography>
              </Breadcrumbs>
            </Box>
            <Container maxWidth="xl" sx={{ my: 4, px: "0 !important" }}>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{ mt: 8 }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity={snackbarSeverity}
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography variant="h3" component="h1">
                  <b>Constructor de Exámenes</b>
                </Typography>
                <Box>
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<ListAltIcon />}
                    onClick={() => navigate("/poolLista")}
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      bgcolor: teal[500],
                      "&:hover": { bgcolor: teal[700] },
                    }}
                  >
                    Gestionar Pools
                  </Button>
                  <IconButton
                    onClick={() => navigate("/poolLista")}
                    sx={{
                      display: { xs: "inline-flex", sm: "none" },
                      bgcolor: teal[500],
                      color: "white",
                      "&:hover": { bgcolor: teal[700] },
                      width: 48,
                      height: 48,
                    }}
                  >
                    <ListAltIcon />
                  </IconButton>
                </Box>
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={5}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      height: "100%",
                      position: "relative",
                      bgcolor: theme.palette.background.alt,
                      borderRadius: 4,
                    }}
                  >
                    <Typography variant="h6">
                      1. Configura el Exámen
                    </Typography>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Nombre del Examen"
                          variant="outlined"
                          value={examName}
                          onChange={(e) =>
                            setExamName(e.target.value.toUpperCase())
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          label="Cantidad de Preguntas"
                          variant="outlined"
                          type="number"
                          value={questionLimit}
                          onChange={(e) => setQuestionLimit(e.target.value)}
                          InputProps={{ inputProps: { min: 1 } }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          label="Preguntas para Aprobar"
                          variant="outlined"
                          type="number"
                          value={passingScore}
                          onChange={(e) => setPassingScore(e.target.value)}
                          InputProps={{ inputProps: { min: 1 } }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          label="Tiempo (minutos)"
                          variant="outlined"
                          type="number"
                          value={examTime}
                          onChange={(e) => setExamTime(e.target.value)}
                          InputProps={{ inputProps: { min: 1 } }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Descripción del Examen"
                          variant="outlined"
                          multiline
                          rows={2}
                          value={examDescription}
                          onChange={(e) => setExamDescription(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel>Categoría</InputLabel>
                          <Select
                            value={selectedCategoryId}
                            onChange={(e) =>
                              setSelectedCategoryId(e.target.value)
                            }
                            label="Categoría"
                          >
                            <MenuItem value="Todos">
                              <em>Selecciona una categoría</em>
                            </MenuItem>
                            <MenuItem value="1">Salud</MenuItem>
                            <MenuItem value="2">Nutrición</MenuItem>
                            <MenuItem value="3">WASH</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel>Dificultad</InputLabel>
                          <Select
                            value={selectedDifficulty ?? ""}
                            onChange={(e) =>
                            setSelectedDifficulty(e.target.value ? Number(e.target.value) : null)
                             }
                            label="Dificultad"
                          >
                            <MenuItem value="Todos">
                              <em>Selecciona una dificultad</em>
                            </MenuItem>
                            <MenuItem value={1}>Básico</MenuItem>
                            <MenuItem value={2}>Intermedio</MenuItem>
                            <MenuItem value={3}>Experto</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        height: "280px",
                        overflowY: "auto",
                        position: "relative",
                      }}
                    >
                      {isSelectionDisabled ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            p: 2,
                            textAlign: "center",
                          }}
                        >
                          <Typography variant="h6" color="text.secondary">
                            Completa la configuración para buscar preguntas.
                          </Typography>
                        </Box>
                      ) : filteredPools.length > 0 ? (
                        filteredPools.map((pool) => (
                          <Accordion key={pool.id}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography>{pool.name}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  mb: 1,
                                }}
                              >
                                <Button
                                  size="small"
                                  startIcon={<PlaylistAddCheckIcon />}
                                  onClick={() => handleAddAllFromPool(pool)}
                                >
                                  Seleccionar Todas (Aleatorio)
                                </Button>
                              </Box>
                 <List dense>
  {pool.questions.map((q) => (
    <ListItem
      key={`${pool.id}-${q.id}`}
      secondaryAction={
        <IconButton edge="end" onClick={() => handleAddQuestion(q)}>
          <AddCircleOutlineIcon
            color={
              selectedQuestions.some((sq) => sq.id === q.id)
                ? "disabled"
                : "primary"
            }
          />
        </IconButton>
      }
    >
      <ListItemText primary={q.question} />
    </ListItem>
  ))}
</List>
                            </AccordionDetails>
                          </Accordion>
                        ))
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            color: "text.secondary",
                          }}
                        >
                          <SearchOffIcon sx={{ fontSize: "4rem", mb: 1 }} />
                          <Typography variant="h6">
                            No se encontraron pools con los filtros
                            seleccionados.
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      height: "100%",
                      bgcolor: theme.palette.background.alt,
                      borderRadius: 4,
                    }}
                  >
                    <Typography variant="h6">
                      2. Exámen Actual ({selectedQuestions.length} /{" "}
                      {questionLimit || "?"})
                    </Typography>
                    <Paper
                      variant="outlined"
                      sx={{
                        mt: 2,
                        height: "500px",
                        overflowY: "auto",
                        borderRadius: 4,
                      }}
                    >
                      {selectedQuestions.length === 0 ? (
                        <Box
                          sx={{
                            p: 3,
                            textAlign: "center",
                            color: "text.secondary",
                          }}
                        >
                          <Typography>
                            Las preguntas que selecciones aparecerán aquí.
                          </Typography>
                        </Box>
                      ) : (
                        <List dense>
                          {selectedQuestions.map((q) => (
                            <ListItem
                              key={q.id}
                              secondaryAction={
                                <IconButton
                                  edge="end"
                                  onClick={() => handleRemoveQuestion(q.id)}
                                >
                                  <DeleteIcon color="error" />
                                </IconButton>
                              }
                            >
                              <ListItemText
                                primary={q.question}
                                secondary={`Dificultad: ${q.difficulty}`}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </Paper>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 3,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="error"
                        startIcon={<LayersClearIcon />}
                        onClick={handleClearExam}
                        disabled={selectedQuestions.length === 0}
                      >
                        Limpiar
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={handleSaveExam}
                        sx={{
                          bgcolor: teal[500],
                          "&:hover": { bgcolor: teal[700] },
                        }}
                        disabled={selectedQuestions.length === 0}
                      >
                        Guardar Examen
                      </Button>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      height: "100%",
                      bgcolor: theme.palette.background.alt,
                      borderRadius: 4,
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <FactCheckIcon color="action" />
                      <Typography variant="h6" gutterBottom sx={{ mb: 0 }}>
                        <b>Exámenes Guardados</b>
                      </Typography>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid item xs={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Categoría</InputLabel>
                          <Select
                            value={savedExamCategoryFilter}
                            onChange={(e) =>
                              setSavedExamCategoryFilter(e.target.value)
                            }
                            label="Categoría"
                          >
                            <MenuItem value="Todos">Todas</MenuItem>
                            <MenuItem value="Salud">Salud</MenuItem>
                            <MenuItem value="Nutrición">Nutrición</MenuItem>
                            <MenuItem value="WASH">WASH</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Dificultad</InputLabel>
                          <Select
                            value={savedExamDifficultyFilter}
                            onChange={(e) =>
                              setSavedExamDifficultyFilter(e.target.value)
                            }
                            label="Dificultad"
                          >
                            <MenuItem value="Todos">Todas</MenuItem>
                            <MenuItem value="Basico">Básico</MenuItem>
                            <MenuItem value="Intermedio">Intermedio</MenuItem>
                            <MenuItem value="Experto">Experto</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Box sx={{ height: "480px", overflowY: "auto" }}>
                      {displayedSavedExams.length === 0 ? (
                        <Box
                          sx={{
                            textAlign: "center",
                            color: "text.secondary",
                            pt: 10,
                          }}
                        >
                          <AssignmentIcon sx={{ fontSize: "4rem" }} />
                          <Typography>No hay exámenes que coincidan</Typography>
                        </Box>
                      ) : (
                        <List>
                          {displayedSavedExams.map((exam, index) => (
                            <React.Fragment key={exam.id}>
                              <ListItem
                                secondaryAction={
                                  <IconButton
                                    edge="end"
                                    onClick={(e) => handleMenuOpen(e, exam.id_examen)}
                                  >
                                    <MoreVertIcon />
                                  </IconButton>
                                }
                              >
                                <ListItemIcon sx={{ minWidth: 40 }}>
                                  <ArticleIcon
                                    color={exam.activo ? "success" : "error"}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={exam.titulo_examen}
                                  secondary={
                                    <Box
                                      component="span"
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mt: 0.5,
                                      }}
                                    >
                                      <Typography
                                        component="span"
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        {/* {`${exam.questions.length} preguntas`} */}
                                        </Typography>
                                      <Chip
                                        label={
                                          exam.activo
                                            ? "Activado"
                                            : "Desactivado"
                                        }
                                        color={
                                          exam.activo ? "success" : "error"
                                        }
                                        size="small"
                                        sx={{ ml: 1.5 }}
                                      />
                                    </Box>
                                  }
                                />
                              </ListItem>
                              {index < displayedSavedExams.length - 1 && (
                                <Divider />
                              )}
                            </React.Fragment>
                          ))}
                        </List>
                      )}
                    </Box>
                  </Paper>
                  <Menu
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={handleOpenDetailsModal}>
                      <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                      </ListItemIcon>
                      Detalles
                    </MenuItem>
                    <MenuItem onClick={handleOpenEditModal}>
                      <ListItemIcon>
                        <EditIcon fontSize="small" />
                      </ListItemIcon>
                      Editar
                    </MenuItem>
                    {selectedSavedExam?.isActive ? (
                      <MenuItem onClick={handleDeactivateExam}>
                        <ListItemIcon>
                          <ToggleOffIcon fontSize="small" />
                        </ListItemIcon>
                        Desactivar
                      </MenuItem>
                    ) : (
                      <MenuItem onClick={handleActivateExam}>
                        <ListItemIcon>
                          <ToggleOnIcon fontSize="small" color="success" />
                        </ListItemIcon>
                        Activar
                      </MenuItem>
                    )}
                    <Divider />
                    <MenuItem
                      onClick={handleDeleteExam}
                      sx={{ color: "error.main" }}
                    >
                      <ListItemIcon>
                        <DeleteIcon fontSize="small" color="error" />
                      </ListItemIcon>
                      Eliminar
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
              <Dialog
                open={openDetailsModal}
                onClose={handleCloseDetailsModal}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { borderRadius: 4 } }}
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    bgcolor: theme.palette.background.alt,
                  }}
                >
                  Detalles del Examen
                </DialogTitle>
                <DialogContent
                  sx={{ p: 0, bgcolor: theme.palette.background.alt }}
                >
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={detailsTab}
                      onChange={handleDetailsTabChange}
                      variant="fullWidth"
                      centered
                    >
                      <Tab
                        icon={<InfoIcon />}
                        iconPosition="start"
                        label="Información General"
                      />
                      <Tab
                        icon={<FormatListBulletedIcon />}
                        iconPosition="start"
                        label="Lista de Preguntas"
                      />
                    </Tabs>
                  </Box>
                  {selectedSavedExam && (
                    <Box sx={{ p: 3 }}>
                      {detailsTab === 0 && (
                        <Grid container spacing={3} sx={{ pt: 2 }}>
                          <Grid item xs={12} md={4}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              Nombre del Examen
                            </Typography>
                            <Typography variant="h6">
                              {selectedSavedExam.titulo_examen}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              Categoría
                            </Typography>
                            <Typography variant="body1">
                              {selectedSavedExam.nombre_categoria}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              N° de Preguntas
                            </Typography>
                            <Typography variant="body1">
                              {selectedSavedExam.tamano_examen}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              Preguntas para Aprobar
                            </Typography>
                            <Typography variant="body1">
                              {selectedSavedExam.preguntas_para_aprobar}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              Duración
                            </Typography>
                            <Typography variant="body1">
                              {selectedSavedExam.tiempo_limite_minutos} minutos
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              Estado
                            </Typography>
                            <Box>
                              <Chip
                                label={
                                  selectedSavedExam.activo
                                    ? "Activado"
                                    : "Desactivado"
                                }
                                color={
                                  selectedSavedExam.activo
                                    ? "success"
                                    : "error"
                                }
                                size="small"
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sx={{ mt: 1 }}>
                            <Typography
                              variant="overline"
                              color="text.secondary"
                            >
                              Descripción
                            </Typography>
                            <Typography variant="body1">
                              {selectedSavedExam.description ||
                                "Sin descripción."}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                      {detailsTab === 1 && (
                        <Box sx={{ height: 400, overflowY: "auto" }}>
                          <List>
          {selectedSavedExam.preguntas?.map((p, index) => (
  <Box key={p.id_pregunta} sx={{ mb: 3 }}>
    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
      {(p.orden ?? index + 1)}. {p.enunciado_pregunta}
    </Typography>
    <List dense sx={{ pl: 2 }}>
      {p.respuestas.map((ans, ansIndex) => (
        <ListItem
          key={ansIndex}
          sx={{
            ...(ans.es_correcta && {
              bgcolor: green[50],
              borderRadius: 1,
            }),
          }}
        >
          <ListItemText
            primary={ans.texto_respuesta}
            primaryTypographyProps={{
              ...(ans.es_correcta && { fontWeight: "bold" }),
            }}
          />
          {ans.es_correcta && (
            <Chip label="Correcta" color="success" size="small" />
          )}
        </ListItem>
      ))}
    </List>
  </Box>
))}

                          </List>
                        </Box>
                      )}
                    </Box>
                  )}
                </DialogContent>
                <Divider />
                <DialogActions
                  sx={{ p: 2, bgcolor: theme.palette.background.alt }}
                >
                  <Button
                    onClick={handleCloseDetailsModal}
                    variant="contained"
                    color="error"
                  >
                    Cerrar
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={openEditModal}
                onClose={handleCloseEditModal}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { borderRadius: 4 } }}
              >
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    bgcolor: theme.palette.background.alt,
                  }}
                >
                  Editando Examen: {editingExam?.name}
                </DialogTitle>
                <DialogContent
                  sx={{ p: 0, bgcolor: theme.palette.background.alt }}
                >
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={editTab}
                      onChange={handleEditTabChange}
                      variant="fullWidth"
                      centered
                    >
                      <Tab
                        icon={<SettingsIcon />}
                        iconPosition="start"
                        label="Configuración General"
                      />
                      <Tab
                        icon={<RuleIcon />}
                        iconPosition="start"
                        label="Gestión de Preguntas"
                      />
                    </Tabs>
                  </Box>
                  {editingExam && (
                    <Box sx={{ p: 3 }}>
                      {editTab === 0 && (
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Nombre del Examen"
                              value={editingExam.name}
                              onChange={(e) =>
                                handleEditingExamChange(
                                  "name",
                                  e.target.value.toUpperCase()
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Descripción"
                              multiline
                              rows={3}
                              value={editingExam.description}
                              onChange={(e) =>
                                handleEditingExamChange(
                                  "description",
                                  e.target.value
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="N° de Preguntas"
                              type="number"
                              value={editingExam.questionLimit}
                              onChange={(e) =>
                                handleEditingExamChange(
                                  "questionLimit",
                                  parseInt(e.target.value, 10)
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Preguntas para Aprobar"
                              type="number"
                              value={editingExam.passingScore}
                              onChange={(e) =>
                                handleEditingExamChange(
                                  "passingScore",
                                  parseInt(e.target.value, 10)
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Duración (minutos)"
                              type="number"
                              value={editingExam.durationInSeconds / 60}
                              onChange={(e) =>
                                handleEditingExamChange(
                                  "durationInSeconds",
                                  parseInt(e.target.value, 10) * 60
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControl fullWidth>
                              <InputLabel>Categoría</InputLabel>
                              <Select
                                label="Categoría"
                                value={editingExam.category}
                                onChange={(e) =>
                                  handleEditingExamChange(
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <MenuItem value="Salud">Salud</MenuItem>
                                <MenuItem value="Nutrición">Nutrición</MenuItem>
                                <MenuItem value="WASH">WASH</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}
                      {editTab === 1 && (
                        <Grid container spacing={2} sx={{ height: 400 }}>
                          <Grid
                            item
                            xs={6}
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold" }}
                            >
                              Preguntas del Examen (
                              {editingExam.questions.length})
                            </Typography>
                            <Paper
                              variant="outlined"
                              sx={{
                                flexGrow: 1,
                                overflowY: "auto",
                                mt: 1,
                                borderRadius: 4,
                              }}
                            >
                              <List dense>
                                {editingExam.questions.map((q) => (
                                  <ListItem
                                    key={q.id}
                                    secondaryAction={
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleEditingExamChange(
                                            "questions",
                                            editingExam.questions.filter(
                                              (item) => item.id !== q.id
                                            )
                                          )
                                        }
                                      >
                                        <DeleteIcon
                                          fontSize="small"
                                          color="error"
                                        />
                                      </IconButton>
                                    }
                                  >
                                    <ListItemText primary={q.question} />
                                  </ListItem>
                                ))}
                              </List>
                            </Paper>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: "bold" }}
                            >
                              Añadir Preguntas Disponibles
                            </Typography>
                            <Grid container spacing={1} sx={{ my: 0.5 }}>
                              <Grid item xs={6}>
                                <FormControl size="small" fullWidth>
                                  <InputLabel>Categoría</InputLabel>
                                  <Select
                                    value={editModalCategoryFilter}
                                    label="Categoría"
                                    onChange={(e) =>
                                      setEditModalCategoryFilter(e.target.value)
                                    }
                                  >
                                    <MenuItem value="Todos">Todas</MenuItem>
                                    <MenuItem value="Salud">Salud</MenuItem>
                                    <MenuItem value="Nutrición">
                                      Nutrición
                                    </MenuItem>
                                    <MenuItem value="WASH">WASH</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <FormControl size="small" fullWidth>
                                  <InputLabel>Dificultad</InputLabel>
                                  <Select
                                    value={editModalDifficultyFilter}
                                    label="Dificultad"
                                    onChange={(e) =>
                                      setEditModalDifficultyFilter(
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value="Todos">Todas</MenuItem>
                                    <MenuItem value="Basico">Básico</MenuItem>
                                    <MenuItem value="Intermedio">
                                      Intermedio
                                    </MenuItem>
                                    <MenuItem value="Experto">Experto</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                            <Paper
                              variant="outlined"
                              sx={{
                                flexGrow: 1,
                                overflowY: "auto",
                                borderRadius: 4,
                              }}
                            >
                              {/* <List dense>
                                {availablePools
                                  .filter(
                                    (p) =>
                                      editModalCategoryFilter === "Todos" ||
                                      p.category === editModalCategoryFilter
                                  )
                                  .flatMap((pool) => pool.questions)
                                  .filter(
                                    (q) =>
                                      editModalDifficultyFilter === "Todos" ||
                                      q.difficulty === editModalDifficultyFilter
                                  )
                                  .filter(
                                    (q) =>
                                      !editingExam.questions.some(
                                        (eq) => eq.id === q.id
                                      )
                                  )
                                  .map((q) => (
                                    <ListItem
                                      key={q.id}
                                      secondaryAction={
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleEditingExamChange(
                                              "questions",
                                              [...editingExam.questions, q]
                                            )
                                          }
                                        >
                                          <AddCircleOutlineIcon
                                            fontSize="small"
                                            color="primary"
                                          />
                                        </IconButton>
                                      }
                                    >
                                      <ListItemText primary={q.question} />
                                    </ListItem>
                                  ))}
                              </List> */}
                            </Paper>
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                  )}
                </DialogContent>
                <Divider />
                <DialogActions
                  sx={{ p: 2, bgcolor: theme.palette.background.alt }}
                >
                  <Button
                    onClick={handleCloseEditModal}
                    variant="contained"
                    color="error"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={handleUpdateExam}
                    variant="contained"
                    sx={{
                      bgcolor: teal[500],
                      "&:hover": { bgcolor: teal[700] },
                    }}
                  >
                    Guardar Cambios
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>
          </Box>
        </>
      ) : (
        <Box m="1.5rem 2.5rem">
          <Restricted />
        </Box>
      )}
    </div>
  );
};

export default CrearTest;
